import {
	themeOverwriteNoordhoff,
	themeOverwritePlantyn
} from './../config/ThemeOverwrite';
import { ThemeOptions } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { Opco } from './../models/types';
import { useOpco } from '.';

export function useOpcoTheme(): ThemeOptions {
	const opco: Opco = useOpco();
	const [theme, setTheme] = useState<ThemeOptions>(themeOverwriteNoordhoff);

	useEffect(() => {
		selectThemeByOpco(opco);
	}, [opco]);

	function selectThemeByOpco(opco: Opco): void {
		switch (opco) {
			case Opco.Noordhoff:
				setTheme(themeOverwriteNoordhoff);
				break;
			case Opco.Plantyn:
				setTheme(themeOverwritePlantyn);
				break;
		}
	}

	return theme;
}
